import { createSvgIcon } from "@mui/material";

// drawn on a 14 grid, the stroke is scaled to match the 1.66667 / 20 stroke of the other section icons
export const IconSetIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
        <path d="M8.74999 7.00008C8.74999 7.96658 7.96649 8.75008 6.99999 8.75008C6.0335 8.75008 5.24999 7.96658 5.24999 7.00008C5.24999 6.03358 6.0335 5.25008 6.99999 5.25008C7.96649 5.25008 8.74999 6.03358 8.74999 7.00008ZM1.43398 7.00006C2.1773 4.63343 4.3883 2.91675 7.00025 2.91675C9.61222 2.91675 11.8232 4.63345 12.5665 7.0001C11.8232 9.36674 9.61221 11.0834 7.00026 11.0834C4.3883 11.0834 2.17729 9.36672 1.43398 7.00006Z" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'IconSetIcon'
)
